import PropTypes from 'prop-types';
import React from 'react';

const ActivityBrandItem = ({brandNotes}) => (
    <div className="activity">
        <div className="activity-item-header">Brand Notes</div>
        <div className="activity-item-body brand-note">
            <span>{brandNotes}</span>
        </div>
    </div>
);
ActivityBrandItem.propTypes = {
    brandNotes: PropTypes.string
};

export default ActivityBrandItem;



// WEBPACK FOOTER //
// ./approval_queues/components/activity_feed/activity_brand_item.js